import { theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { media } = theme;

export const TileWrapper = styled.div<{ tileThreshold: number }>`
  display: grid;
  margin: 0 auto;
  padding: 0 1rem;
  row-gap: 1rem;

  @media (min-width: ${media.sm}) {
    gap: 1rem 1rem;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${media.md}) {
    grid-template-columns: ${({ tileThreshold }) =>
      tileThreshold > 4 || tileThreshold === 3 ? `repeat(3, 1fr);` : `repeat(2, 1fr)`};
  }
`;
